<template>
  <div class="my-10">
    <div class="flex flex-wrap justify-between px-4 items-center">
      <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">{{ __('Jobs') }}</h1>

      <div class="flex flex-wrap items-center flex-shrink-0 w-full justify-center md:w-auto md:justify-start">
        <div class="relative flex items-center w-full mb-4 sm:w-auto sm:mb-0">
          <input class="text-lg relative w-full sm:w-64 pl-6 pr-10 py-3 rounded-lg border border-gray-600 focus:border-coral-400 placeholder-gray-400" autocomplete="off" type="text" name="search" :placeholder="__('Search job...')" v-model="term" @keypress.enter="search">
          <div class="w-4 h-4 absolute right-0 mr-3 z-10 cursor-pointer" @click="search">
            <icon name="search" class="text-gray-600 fill-current"></icon>
          </div>
        </div>

        <div v-if="authUser().permissions.create_jobs" class="sm:ml-6">
          <inertia-link :href="route('quickJobs.create')" class="btn-primary">
            {{ __('Add job') }}
          </inertia-link>
        </div>
      </div>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 overflow-x-auto">
      <table class="min-w-md w-full" v-if="jobs.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 w-10">{{ __('Id') }}</th>
          <th class="p-4 w-10">{{ __('Order number') }}</th>
          <th class="p-4 text-left min-w-40">{{ __('Registration number') }}</th>
          <th class="p-4 text-left min-w-40">{{ __('Client') }}</th>
          <th class="p-4 text-left min-w-40">{{ __('Car') }}</th>
          <th class="p-4 text-left min-w-40">{{ __('Creator') }}</th>
          <th class="p-4 text-left w-32">{{ __('Rating') }}</th>
          <th class="p-4 text-left min-w-40">{{ __('Date') }}</th>
          <th class="p-4 text-left w-40">{{ __('Status') }}</th>
          <th class="p-4 text-right w-24">{{ __('Actions') }}</th>
        </tr>

        <tr v-for="(job, index) in jobs.data" :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 text-center">
            {{ job.id }}
          </td>
          <td class="p-4 text-center">
            <span class="rounded block px-2 py-1 bg-gray-200 text-sm whitespace-nowrap" v-if="job.external_id">
              <icon name="suitcase" class="w-4 h-4 inline-block fill-current"></icon> {{ job.external_id }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="p-4 w-32">
            <inertia-link :href="route('jobs.edit', {job: job.id})" class="font-semibold bg-white py-1 px-2 border border-gray-300 rounded inline-block hover:bg-coral-400 focus:bg-coral-400 hover:text-white focus:text-white">
              {{ job.car ? job.car.registration_number : quickJobRegistrationNumber(job) }}
            </inertia-link>
          </td>
          <td class="p-4">
            {{ job.client ? job.client.name : '-' }}
          </td>
          <td class="p-4">
            <span v-if="job.car">{{ job.car.car_make.name }} {{ job.car.model }}</span>
            <span v-else>-</span>
          </td>
          <td class="p-4">
            <span>{{ job.creator.name }}</span>
          </td>
          <td class="p-3 w-32">
            <stars v-if="job.rating !== null" :rating="job.rating"></stars>
            <span v-else>-</span>
          </td>
          <td class="p-3">{{ job.created_at }}</td>
          <td class="p-4"><span class="job-status inline-block" :class="job.status">
            {{ job.status_label }}
          </span></td>
          <td class="px-4 text-center">
            <div class="flex items-center w-full justify-end">
              <inertia-link :href="route('jobs.edit', {job: job.id})" class="list-edit-button mr-2">
                <icon name="edit" class="w-4 h-4 fill-current"></icon>
              </inertia-link>

              <button @click="destroy(job)" class="list-delete-button" v-if="authUser().permissions.delete_jobs">
                <icon name="delete" class="w-4 h-4 fill-current"></icon>
              </button>
            </div>
          </td>
        </tr>
      </table>
      <div v-else>
        {{ __('No jobs at the moment...') }}
      </div>
    </div>
    <pagination :links="jobs.meta.links"/>
  </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';
import Stars from '@/Shared/Stars';
import _ from 'lodash';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Jobs'),
    };
  },
  props: {
    jobs: Object,
    view: Object,
    filters: null,
  },
  data() {
    return {
      term: this.filters.term,
    };
  },
  components: {
    Layout,
    Pagination,
    Icon,
    Stars,
  },
  methods: {
    quickJobRegistrationNumber(job) {
      if (!job.hasOwnProperty('meta') || !job.meta || !job.meta.hasOwnProperty('registration_number')) {
        return null;
      }

      return job.meta.registration_number;
    },
    search: _.throttle(function () {
      this.$inertia.get(this.route('jobs.index', { 'term': this.term }), {}, { replace: true });
    }, 150),
    destroy(job) {
      if (confirm(this.__('Are you sure you want to delete this job?'))) {
        this.$inertia.delete(this.route('jobs.destroy', { job: job.id }));
      }
    },
  },
};
</script>
